import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import ReduxStoreProvider from "providers/ReduxStoreProvider";
import MuiThemeProvider from "./providers/MuiThemeProvider";
import MuiDatePickerProvider from "./providers/MuiDatePickerProvider";
import MuiSnackbarProvider from "./providers/MuiSnackbarProvider";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import instrumentation from "services/instrumentation";

instrumentation.init();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ReduxStoreProvider>
      <MuiThemeProvider>
        <MuiDatePickerProvider>
          <MuiSnackbarProvider>
            <div className="min-h-screen overflow-hidden">
              <RouterProvider router={router} />
            </div>
          </MuiSnackbarProvider>
        </MuiDatePickerProvider>
      </MuiThemeProvider>
    </ReduxStoreProvider>
  </StrictMode>
);
